
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login-host",
      function () {
        return require("private-next-pages/login-host.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login-host"])
      });
    }
  